import { render, staticRenderFns } from "./customSwiper.vue?vue&type=template&id=b84a47fe&"
import script from "./customSwiper.vue?vue&type=script&lang=js&"
export * from "./customSwiper.vue?vue&type=script&lang=js&"
import style0 from "./customSwiper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports